import { ROUTER_PATHS, gridSize, gridSizeMdLg6 } from "@/shared";
import { CustomTextArea, LoaderComponent, SingleTableBoxScene, TabTextLabel } from "@/shared/components/ui";
import { Grid, Paper } from "@mui/material";
import { MaterialTransferido, EstadoSolicitudTransferencia, ISolicitudTrasladoForm } from "@/shared/interfaces";
import { useEffect, useState } from "react";
import { ScrollableDialogProps } from "@/shared/components/ui/Dialogs";
import { useForm } from "react-hook-form";
import { useUiStore } from "@/store/ui";
import { useNavigate, useParams } from "react-router-dom";
import { useFetchPutSolicitudTraslado, useFetchSolicitudTransferenciaInventarioById } from "@/shared/actions/erp";
import DatosTransferenciaComponente from "../componente/datos-transferencia-componente";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import SampleTablePagination from "@/shared/components/ui/SampleTablePagination";
import { useTableColumnsInventarioSerie } from "@/shared/hooks/useTableColumnsInventarioSerie";
import { useCargarSeriesProductos } from "@/store/erp/productos/useCargarSeriesProductos.store";

export default function RevisionSolicitudTransferenciaInventarioAccionPage() {

  const { idsolicitud } = useParams();
  const navigate = useNavigate();

  //STATE
  const [openModalRechazo, setOpenModalRechazo] = useState<boolean>(false);
  //STORE
  const setAlert = useUiStore(s => s.setAlert);
  const setConfirmDialog = useUiStore(s => s.setConfirmDialog);
  const setConfirmDialogIsOpen = useUiStore(s => s.setConfirmDialogIsOpen);
  const handleCopiarLista = useCargarSeriesProductos(s => s.handleCopiarLista)
  const clearSelectedItems = useCargarSeriesProductos(s => s.clearSelectedItems)
  const productos = useCargarSeriesProductos(s => s.productos)
  const paginatedData = useCargarSeriesProductos(s => s.paginatedData)
  const setPagination = useCargarSeriesProductos(s => s.setPagination)
  const pagination = useCargarSeriesProductos(s => s.pagination)

  //FETCH
  const { data: dataSolicitudInventario, isLoading: isLoadingSolicitudInventario } = useFetchSolicitudTransferenciaInventarioById(idsolicitud!);
  const putTrasladoInventario = useFetchPutSolicitudTraslado();

  //FORM
  const form = useForm<ISolicitudTrasladoForm, any, ISolicitudTrasladoForm>({
    //resolver: yupResolver(newTransferenciaInventarioSchema)
  });

  const {
    reset,
    control,
    formState: { errors },
  } = form;

  //COLUMNA DE PRODUCTOS
  const { columnsRevisarSolicitudTransferencia } = useTableColumnsInventarioSerie();

  useEffect(() => {
    if (isLoadingSolicitudInventario) return;
    const productos: MaterialTransferido[] = dataSolicitudInventario?.productos!
    handleCopiarLista(productos);
    return () => {
      clearSelectedItems();
    }
  }, [isLoadingSolicitudInventario])


  const fnOnsSubmit = async () => {
    //CONVERTIR SOLICITUD TRASLADO EN TRASLADO DE INVENTARIO EN ESTADO EN ESPERA

    setConfirmDialogIsOpen(true);

    setConfirmDialog({
      isOpen: true,
      title: '¡Confirmar!',
      subtitle:
        '¿Deseas proceder con la aprobación de la solicitud de traslado de inventario? Esta acción no se puede deshacer. ¿Estás seguro de continuar?',
      onClose() {
        setConfirmDialogIsOpen(false);

      },
      async onConfirm() {

        setConfirmDialogIsOpen(false);

        const resp = await putTrasladoInventario.mutateAsync({
          id: dataSolicitudInventario?.id_solicitudtraslado!,
          data: {
            estado_solicitud: EstadoSolicitudTransferencia.APROBADO
          }
        });

        if (resp.code == 200) {

          //CAMBIAR DE ESTADO DE SOLICITUD DE ESPERA POR APROBADO
          clearSelectedItems();

          setConfirmDialogIsOpen(true);
          setConfirmDialog({
            cancelTextBtn: 'Salir',
            isOpen: true, title: 'Solicitud Aceptada', 
            subtitle: 'Solicitud de traslado de Inventario creada correctamente. ¿Continuar con el despacho de los productos?',
            onClose() {
              setConfirmDialogIsOpen(false)
              navigate(ROUTER_PATHS.inventario.revisarSolicitudInventarioNav);
            }, onConfirm() {
              setConfirmDialogIsOpen(false);
              navigate(`${ROUTER_PATHS.inventario.trasladoInventarioIngresoNav}/${resp.data.id_solicitudtraslado}`)
            },
          });
        }
        setAlert(true, resp.message, resp.status);

      },
      cancelTextBtn: 'Cerrar',
    });



  }

  if (isLoadingSolicitudInventario) return <LoaderComponent />


  return (
    <SingleTableBoxScene
      title="Revisión de Solicitud de Transferencia"
      visibleReport={false}
      enableBackBtn={true}
      backPageUrl={ROUTER_PATHS.inventario.revisarSolicitudInventarioNav}
      enableCreateOrEditBtn={true}
      textCreateOrEditBtn="Aprobar"
      iconCreateOrEdit={<CheckCircleIcon />}
      fnCreateOrEdit={fnOnsSubmit}
      enableAccionBtn={true}
      fnAccionBtn={() => setOpenModalRechazo(true)}
      gridSizeBtnAccion={gridSizeMdLg6}
      gridSizeTitle={gridSizeMdLg6}
    >

      <Grid container spacing={3}>
        <DatosTransferenciaComponente
          control={control}
          errors={errors}
          form={form}
          reset={reset}
          dataTransferenciaInventario={dataSolicitudInventario as any}
        />

        <Grid item {...gridSize}>
          <Paper className="paper-producto">
            <Grid container spacing={1} justifyContent={'space-between'} alignItems={'center'}>
              <Grid item >
                <TabTextLabel text={'Item Solicitados'} mt={0} pb={0} pl={0} pt={0} />
              </Grid>

              <div className="linea"></div>
              <Grid item xs={12}>

                <SampleTablePagination
                  columns={columnsRevisarSolicitudTransferencia}
                  data={paginatedData}
                  rowCount={productos.length}
                  setPagination={setPagination}
                  pagination={pagination}
                  rowNumber={true}
                />

              </Grid>

            </Grid>
          </Paper>

        </Grid>

      </Grid>

      <ScrollableDialogProps
        open={openModalRechazo}
        title="Confirmar"
        dialogContentText="¿Estas seguro de rechazar la solicitud de transferencia?"
        onClose={() => setOpenModalRechazo(false)}
        onConfirm={async () => {
          const resp = await putTrasladoInventario.mutateAsync({
            id: dataSolicitudInventario?.id_solicitudtraslado!, data: {
              estado_solicitud: EstadoSolicitudTransferencia.RECHAZADO
            }
          });

          if (resp.code == 200) navigate(ROUTER_PATHS.inventario.revisarSolicitudInventarioNav)
          setAlert(true, resp.message, resp.status);
        }}
        // content
        minWidth="48%"
        contentNode={

          <Grid container spacing={2}>

            <CustomTextArea
              label="Motivo"
              name="motivo"
              control={form.control}
              defaultValue={
                form.getValues('motivo') || ''
              }
              error={form.formState.errors.motivo}
              helperText={
                form.formState.errors.motivo?.message
              }
              required={false}
            />


          </Grid>

        }
      />

    </SingleTableBoxScene>
  );

}